import { motion } from "framer-motion";

const tracks = [
  { number: "01", title: "Piątkowski Detroit" },
  { number: "02", title: "Mindset" },
  { number: "03", title: "Na Wizji" },
  { number: "04", title: "ADRENALINA" },
  { number: "05", title: "Reconnect" },
  { number: "06", title: "AGONIA" },
  { number: "07", title: "Pierwsze Miejsce" },
];

export default function Tracklist() {
  return (
    <section
      id="tracklist"
      data-testid="tracklist-section"
      className="relative py-24 md:py-32"
    >
      <div className="max-w-4xl mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.6 }}
        >
          <h2
            className="font-['Oswald'] text-3xl md:text-4xl font-bold uppercase tracking-tighter mb-2"
            data-testid="tracklist-section-title"
          >
            Tracklista
          </h2>
          <div className="w-16 h-[2px] bg-[#EB0023] mb-10" />
        </motion.div>

        <div className="flex flex-col">
          {tracks.map((track, idx) => (
            <motion.div
              key={track.number}
              data-testid={`track-item-${track.number}`}
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.4, delay: idx * 0.08 }}
              className="track-item flex items-center gap-6 py-5 cursor-default group"
            >
              <span className="font-['Manrope'] text-sm text-[#32558B] group-hover:text-[#EB0023] transition-colors min-w-[2rem]">
                {track.number}
              </span>
              <span className="font-['Oswald'] text-xl md:text-2xl uppercase tracking-wider group-hover:tracking-[0.15em] transition-all">
                {track.title}
              </span>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
